export class SkillsModel {
  skills: number[] = [];
  userId: number;
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/experience/skills.model.ts